import Projects from "../components/sections/projects/Projects";

const PortfolioPage = () => {
  return (
    <div>
      <Projects />
    </div>
  );
};

export default PortfolioPage;
